import { BASE_URL } from "./constants";
import { postAsync } from "./helpers";

const baseUrl = `${BASE_URL}open/`;

export const addContestEmailAsync = async (email) => await postAsync(`${baseUrl}submit_contest_email`, { email });
export const addUfAtHomeEmailAsync = async (first_name, last_name, email) => postAsync(`${baseUrl}submit_ufAtHome_emails`, { first_name, last_name, email });